import { AdminModel } from "./AdminModel";

/**
 * * Модель пользователя
 */
export class UserModel {
  /**ID */
  Id!: number;
  /** Имя */
  FirstName: string;
  /**  Фамилия */
  LastName: string;
  /** Отчетсво */
  MiddleName: string;
  /**Фото */
  Photo!: string;
  /**Цвет аватарки */
  AvatarColor?: string;

  /**Инициалы имени */
  get AvatarInitials() {
    return `${this.FirstName?.[0].toLocaleUpperCase() || ""}${this.LastName?.[0].toLocaleUpperCase() || ""}`;
  }

  /**Инициалы пользователя */
  get Initials() {
    return `${this.LastName} ${this.FirstName} ${this.MiddleName}`;
  }

  constructor(obj?: Partial<UserModel>) {
    Object.assign(this, obj);
  }
}
